import { Prisma } from "@superwall/db";
import { PaywallId } from "@superwall/drizzle/branded";
import { Schema } from "effect";
const CursorSchema = Schema.Struct({
    id: Schema.Number,
    archived: Schema.Boolean
});
const CursorUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(CursorSchema));
const OrderBy = Schema.Struct({
    id: Schema.Enums(Prisma.SortOrder)
});
const OrderByUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(OrderBy));
export const UrlParams = Schema.Struct({
    limit: Schema.NumberFromString.pipe(Schema.optionalWith({
        default: ()=>100
    })),
    orderBy: OrderByUrlParams.pipe(Schema.optional),
    cursor: CursorUrlParams.pipe(Schema.optional),
    archived: Schema.BooleanFromString.pipe(Schema.optionalWith({
        default: ()=>false
    }))
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: CursorUrlParams
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
const PaywallIdFromString = Schema.compose(Schema.NumberFromString, PaywallId);
export class Model extends Schema.Class("superwall-api-Paywall-Model")({
    object: Schema.Literal("paywall"),
    id: PaywallIdFromString,
    name: Schema.String,
    applicationId: Schema.NumberFromString,
    // The actual url fed to the paywall
    url: Schema.String.pipe(Schema.annotations({
        description: "The actual url fed to the SDK"
    })),
    previewImageUrl: Schema.String.pipe(Schema.NullOr, Schema.annotations({
        description: "The url to the preview image of the paywall"
    })),
    editorUrl: Schema.String.pipe(Schema.annotations({
        description: "The url to open the paywall editor"
    })),
    v4: Schema.Boolean,
    presentationStyle: Schema.Union(Schema.Literal("FULLSCREEN"), Schema.Literal("MODAL"), Schema.Literal("PUSH"), Schema.Literal("NO_ANIMATION"), Schema.Literal("DRAWER")).pipe(Schema.annotations({
        description: "The presentation style of the paywall"
    })),
    createdAt: Schema.DateFromString,
    updatedAt: Schema.DateFromString,
    archivedAt: Schema.DateFromString.pipe(Schema.NullOr)
}) {
}
export class List extends Schema.Class("superwall-api-Paywall-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}) {
}
